module.exports = __webpack_public_path__ + "img/5.0fc01d46.png";